import { Grid, makeStyles } from '@material-ui/core'
import React from 'react'
import CustomLabel from './CustomLabel'
const useStyles = makeStyles((theme) => ({
  heading: { fontWeight: 'bold', marginBottom: '15px' },
  hide: { display: 'none' },
}))

export default function CustomDetail({ heading, label }) {
  const classes = useStyles()
  return (
    <Grid container>
      {heading && (
        <Grid item lg={6}>
          <CustomLabel label={heading} className={classes.heading} />
        </Grid>
      )}

      <Grid item lg={6}>
        <CustomLabel label={label} style={{ wordBreak: 'break-word' }} />
      </Grid>
    </Grid>
  )
}
